module.exports = __webpack_public_path__ + "img/step-1.a7c2b192.png";